import {
  NavLink as RrNavLink,
  type NavLinkProps as RrNavLinkProps,
} from 'react-router'
import { isFunction } from '#utils/is.ts'
import { twm } from '#utils/twm.ts'

interface NavLinkRenderProps {
  isActive: boolean
  isPending: boolean
  isTransitioning: boolean
}

interface NavLinkProps extends RrNavLinkProps {
  hitArea?: boolean
  activeClass?: string
  pendingClass?: string
}

export function NavLink({
  activeClass,
  children,
  className,
  discover,
  hitArea = false,
  prefetch = 'intent',
  ...props
}: NavLinkProps) {
  const classNameFn = isFunction(className)
    ? className
    : ({ isActive }: NavLinkRenderProps) =>
        twm(
          `hover:text-base-8 ${hitArea ? 'hit-area' : ''} ${isActive ? activeClass || 'text-base-8' : ''}`,
          className
        )

  return (
    <RrNavLink
      {...props}
      className={classNameFn}
      discover={discover}
      prefetch={prefetch}
    >
      {children}
    </RrNavLink>
  )
}
